module.exports = __webpack_public_path__ + "img/videobgc4.43f4f349.png";